import { ProductImportActions } from 'constants/ActionsTypesTs'
import {
	IConfirmImportProductsResponse,
	ImportProductError,
	ImportProductsResponse
} from 'models/ProductImport'

export interface valueState {
	importedProducts: ImportProductsResponse | null
	importedProductsError: ImportProductError | null
	confirmedProducts: IConfirmImportProductsResponse | null
	confirmedProductsError: ImportProductError | null
}

const initialState = {
	importedProducts: null,
	confirmedProducts: null,
	importedProductsError: null,
	confirmedProductsError: null
}

function rootReducer(state: valueState = initialState, action: any) {
	switch (action.type) {
		case ProductImportActions.IMPORT_PRODUCTS:
		case ProductImportActions.CLEAR_IMPORT_PRODUCTS:
		case ProductImportActions.IMPORT_PRODUCTS_TABLE_PAGINATION:
			return { ...state, importedProducts: null, importedProductsError: null }
		case ProductImportActions.IMPORT_PRODUCTS_SUCCESS:
		case ProductImportActions.IMPORT_PRODUCTS_TABLE_PAGINATION_SUCCESS:
			return {
				...state,
				importedProducts: action.payload,
				importedProductsError: null
			}
		case ProductImportActions.IMPORT_PRODUCTS_ERROR:
			return {
				...state,
				importedProductsError: action.payload,
				importedProducts: null
			}
		case ProductImportActions.CONFIRM_IMPORT_PRODUCTS:
			return { ...state, confirmedProducts: null }
		case ProductImportActions.CONFIRM_IMPORT_PRODUCTS_SUCCESS:
			return { ...state, confirmedProducts: action.payload }
		case ProductImportActions.CONFIRM_IMPORT_PRODUCTS_ERROR:
			return {
				...state,
				confirmedProductsError: action.payload,
				confirmedProducts: null
			}
		default:
			return state
	}
}

export default rootReducer
